export const Footer = () => (
  <footer className="py-16 px-6 md:px-10 bg-[#081617] text-[#EADBC8] border-t border-[#FAF6F0]/10 text-sm" data-testid="site-footer">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
      <div className="space-y-3">
        <img
          src="/assets/griham-logo.png"
          alt="Griham Design Studio logo"
          className="h-20 w-auto object-contain rounded-sm"
        />
        <p className="text-xs text-[#EADBC8]/70 max-w-sm">
          Warm, modern interiors rooted in Indian living. Full turnkey execution &amp; online consultations.
        </p>
      </div>

      <nav className="flex flex-wrap gap-6 text-xs text-[#EADBC8]/80" data-testid="footer-nav">
        <a href="#about" data-testid="footer-link-about" className="hover:text-[#E2A435] transition-colors">About</a>
        <a href="#services" data-testid="footer-link-services" className="hover:text-[#E2A435] transition-colors">Services</a>
        <a href="#gallery" data-testid="footer-link-photos" className="hover:text-[#E2A435] transition-colors">Photos</a>
        <a href="#coverage" data-testid="footer-link-coverage" className="hover:text-[#E2A435] transition-colors">Coverage</a>
        <a href="#reviews" data-testid="footer-link-reviews" className="hover:text-[#E2A435] transition-colors">Client Notes</a>
        <a href="#faq" data-testid="footer-link-faq" className="hover:text-[#E2A435] transition-colors">FAQ</a>
        <a href="#contact" data-testid="footer-link-contact" className="hover:text-[#E2A435] transition-colors">Contact</a>
      </nav>

      <div className="text-xs text-[#EADBC8]/50">Griham Design Studio</div>
    </div>
  </footer>
);
